export type StatisticsPreviewMembershipCtaCopy = {
  title: string;
  description: string;
};

export const STATISTICS_PREVIEW_MEMBERSHIP_URL = 'https://app.sellerbox.io/m/membership';

export const STATISTICS_PREVIEW_MEMBERSHIP_CTA_DEFAULT: StatisticsPreviewMembershipCtaCopy = {
  title: '셀러박스 멤버십 이용하기',
  description: '판매 관리를 계속 이용하려면 멤버십을 시작하세요!',
};

export const STATISTICS_PREVIEW_MEMBERSHIP_CTA_EARLY_BIRD: StatisticsPreviewMembershipCtaCopy = {
  title: '지금 가입하면 첫 달 100원',
  description: '부담 없이 시작해보세요. 첫 결제에 한해 적용돼요.',
};

const KOREA_TIME_ZONE = 'Asia/Seoul';

const getKoreanCalendarMonth = (date: Date): number => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: KOREA_TIME_ZONE,
    month: 'numeric',
  }).formatToParts(date);

  return Number(parts.find((part) => part.type === 'month')?.value);
};

export const isStatisticsPreviewEarlyBirdPeriod = (date = new Date()): boolean => {
  const month = getKoreanCalendarMonth(date);

  return month === 5 || month === 6;
};

export const getStatisticsPreviewMembershipCtaCopy = (
  date = new Date(),
): StatisticsPreviewMembershipCtaCopy =>
  isStatisticsPreviewEarlyBirdPeriod(date)
    ? STATISTICS_PREVIEW_MEMBERSHIP_CTA_EARLY_BIRD
    : STATISTICS_PREVIEW_MEMBERSHIP_CTA_DEFAULT;

export const buildStatisticsPreviewMembershipUrl = (cplatToken?: unknown): string => {
  const token = typeof cplatToken === 'string' ? cplatToken.trim() : '';

  if (!token) {
    return STATISTICS_PREVIEW_MEMBERSHIP_URL;
  }

  const queryParams = new URLSearchParams({
    cplatToken: token,
  });

  return `${STATISTICS_PREVIEW_MEMBERSHIP_URL}?${queryParams.toString()}`;
};
